import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import $DB from '../../util/debounce'
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      banners: [
        require('../../assets/image/index/banner-1.png'),
        require('../../assets/image/index/banner-1.png'),
        require('../../assets/image/index/banner-1.png'),
      ],
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        keyboard: {
          enabled: true,
        },
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      huechysList: [],
      user: {
        br_username: '',
        br_phone: '',
        code: '',
        br_sex: '',
      }, //报名信息
      id: null, //活动ID
      isShow: false,
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
    }
  },
  created() {
    this.getHuechysList()
  },
  methods: {
    //取消显示
    closeShow() {
      this.isShow = false
    },
    //显示
    changeShow(id) {
      this.user = {}
      this.id = id
      this.sending = true
      this.isShow = true
    },
    //提交信息
    submit: $DB(function () {
      if (!this.user.br_username) {
        this.$message.error('请输入姓名')
        return
      }
      if (!this.user.br_sex) {
        this.$message.error('请输入性别')
        return
      }
      if (!this.user.br_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入手机号')
        return
      }
      if (!this.user.code) {
        this.$message.error('请输入验证码')
        return
      }
      this.$axios
        .post('/api/index/yue', {
          ...this.user,
          br_id: this.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(res.data.msg)
          }
          this.isShow = false
        })
    }),
    //获取验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.user.br_phone) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.user.br_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.user.br_phone,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = this.second + 'S'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },
    //获取红娘列表
    getHuechysList() {
      this.$axios
        .post('/api/index/newsList', {
          type: 1,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.huechysList = res.data.data.newsList
          } else {
            this.huechysList = []
          }
        })
    },
  },
}
